import { render, staticRenderFns } from "./SignPromptDialog.vue?vue&type=template&id=f3c25030"
import script from "./SignPromptDialog.vue?vue&type=script&lang=js"
export * from "./SignPromptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn})
